<template>
    <div class="Home">
        <div class="Home-frame u-frameMd">
            <h1><span>Zelená</span> kalkulačka</h1>
            <div class="Home-perex" v-html="mainText"></div>
        </div>
        <div class="Home-bottom">
            <div class="Home-frame u-frameMd">
                <h2 class="u-secondHeading u-textCenter">{{ subTitle }}</h2>
                <div class="Home-links">
                    <router-link to="/konfigurator-zahrad">
                        <img src="/images/type-whole-ico.png" alt="Projekt zahrady a jejích prvků">
                        <span>Projekt zahrady</span>
                    </router-link>
                    <router-link to="/udrzba-zahrad">
                        <img src="/images/type-maintenance-ico.png" alt="Údržba zahrady">
                        <span>Údržba zahrady</span>
                    </router-link>
<!--                    <router-link to="/realizace-zahrad">-->
<!--                        <img src="/images/type-realization-ico.png" alt="Realizace zahrady a jejích stavebních prvků">-->
<!--                        <span>Realizace zahrady</span>-->
<!--                    </router-link>-->
                    <!--router-link to="/">
                        <img src="/images/type-whole-ico.png" alt="Doplňky Vaší zahrady">
                        <span>Doplňky Vaší zahrady</span>
                    </router-link-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {reactive, toRefs} from 'vue';
import {stripTags} from "../utils/utils";
import {getTextData} from "../api/api";

export default {
    async setup() {
        const state = reactive({
            subTitle: '',
            mainText: ''
        });
        const data = await getTextData();
        state.subTitle = stripTags(data['subtitle-hp']);
        state.mainText = data['text-hp'];

        return {
            ...toRefs(state)
        }
    }
}
</script>

<style lang="scss" scoped>
    .Home {
        &-frame {
            position: relative;
        }

        &-perex {
            margin: 0 0 3em;
        }

        &-bottom {
            background: url('/images/home-bg.jpg') no-repeat center center;
            background-size: cover;
            min-height: 730px;
            position: relative;
            padding-bottom: 4rem;
            @media(max-width: 550px) {
                min-height: 600px;
            }

            &:before {
                content: ' ';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);
                height: 400px;
                max-height: 100%;
            }
        }

        &-links {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 1.25em;
            @media(max-width: 880px) {
                grid-template-columns: 1fr;
            }

            a {
                background: var(--colorBrand);
                color: rgb(255, 255, 255);
                font-size: 1.6em;
                font-weight: 700;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 1.25em 1em;
                cursor: pointer;
                transition: all 0.25s ease-in-out 0s;
                text-decoration: none;
                line-height: 1.4;
                @media (max-width: 580px) {
                    font-size: var(--textMd);
                }

                &:hover {
                    background: var(--colorBrandDarken);
                }

                &:last-child {
                    border-right: none;
                }

                span {
                    margin-left: 1em;
                    @media (max-width: 580px) {
                        flex: 1;
                    }
                }

                img {
                    width: 3.2em;
                }
            }
        }
    }
</style>
